export default "__VITE_ASSET__CDI2xzY___"